@if (country === 'ch') {
  <div class="a-link">
    <h3 class="privacy-title-text">
      <T
      str="Privacy Settings"
      key="customerPortal.customer-portal.privacy.privacysettings"
      tags="customer-portal, 3.1"
    ></T>
  </h3>
  <!-- prettier-ignore -->
  @if (lang) {
    <p
      class="font-efSans text-sm text-justify text-mat-ef-revolution-primary-500"
      [innerHTML]="getTranslation1()"
    ></p>
  }
</div>
}

@if (country === 'de') {
  <div class="CTP-gdpr a-link block">
    <div class="privacy-title-text">
      {{ 'data-protection' | sharedTranslate }}
    </div>
    @if (newGdprNotice) {
      <div
        class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
        >
        <!-- prettier-ignore -->
        <p
          [innerHTML]="getTranslation2()"
        ></p>
        <!-- prettier-ignore -->
        <p
          [innerHTML]="getTranslation3()"
        ></p>
      </div>
    }
    @if (!newGdprNotice) {
      <div
        class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
        >
        <p>
          {{ 'consent-channels-message' | sharedTranslate }}
        </p>
      </div>
    }
    @if (!group) {
      <p
        class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
        >
        *
        <T
        str="No consents provided."
        key="customerPortal.customer-portal.communication.noconsents"
        tags="customer-portal, 3.1"
      ></T>
    </p>
  }
  @if (group) {
    <mat-list class="gdpr-list">
      <mat-list-item class="hidden md:block border-b">
        <div
          [ngStyle]="getStyles()"
          class="grid w-full items-center uppercase text-mat-ef-revolution-grey-two-500"
          >
          <h3></h3>
          <h3></h3>
          @for (channel of headingChannels; track channel) {
            <h3
              class="font-light font-efSans text-mat-ef-revolution-grey-two-500 flex justify-end"
              >
              <ng-container
                *ngTemplateOutlet="communication; context: { channel: channel }"
              ></ng-container>
            </h3>
          }
        </div>
        <mat-divider></mat-divider>
      </mat-list-item>
      <mat-divider class="block md:hidden relative w-full"></mat-divider>
      @if (dealers?.length > 0) {
        <mat-list-item>
          @for (d of dealers; track d) {
            <div
              matListItemTitle
              [ngStyle]="getStyles()"
              class="hidden md:grid w-full items-center"
              >
              <span class="flex flex-col col-span-2">
                <span
                  class="font-efSans font-semibold text-mat-ef-revolution-primary-500"
                  >
                  {{ d.name }}
                </span>
                <span class="font-efSans-primary text-sm">
                  {{ d.street }}{{ d.zip ? ', ' + d.zip : '' }} {{ d.city }}
                </span>
              </span>
              @for (channel of headingChannels; track channel) {
                <span
                  class="grid-list-items list-none"
                  >
                  @if (!checkIfDisabled(d, channel.name)) {
                    <mat-checkbox
                      class="h-6 w-6 float-right"
                      [disabled]="!checkIfExist(d, channel.name)"
                      (click)="errorMessage(channel.name)"
                      (keyup)="errorMessage(channel.name)"
                      color="primary"
                      [checked]="getConsentDealer(d.id, channel.name)"
                      (change)="updateConsentValue('dealer', d.id, channel.name, $event)"
                    ></mat-checkbox>
                  }
                </span>
              }
            </div>
          }
          @for (d of dealers; track d) {
            <div matListItemLine class="grid md:hidden">
              <span class="flex flex-col">
                <span class="font-semibold font-efSans-primary">
                  {{ d.name }}
                </span>
                <span class="font-efSans-primary text-sm">
                  {{ d.street }}{{ d.zip ? ', ' + d.zip : '' }} {{ d.city }}
                </span>
              </span>
              <div class="flex flex-col gap-5 my-4">
                @for (channel of headingChannels; track channel) {
                  <span
                    class="grid-list-items flex justify-between items-center"
                    [ngClass]="{ hidden: checkIfDisabled(d, channel.name) }"
                    >
                    <h6 matListItemLine>
                      @if (!checkIfDisabled(d, channel.name)) {
                        <ng-container
                  *ngTemplateOutlet="
                    communication;
                    context: { channel: channel }
                  "
                        ></ng-container>
                      }
                    </h6>
                    @if (!checkIfDisabled(d, channel.name)) {
                      <mat-checkbox
                        class="h-6 w-6"
                        [disabled]="!checkIfExist(d, channel.name)"
                        (click)="errorMessage(channel.name)"
                        (keyup)="errorMessage(channel.name)"
                        color="primary"
                        [checked]="getConsentDealer(d.id, channel.name)"
              (change)="
                updateConsentValue('dealer', d.id, channel.name, $event)
              "
                      ></mat-checkbox>
                    }
                  </span>
                }
              </div>
            </div>
          }
          <mat-divider></mat-divider>
        </mat-list-item>
      }
      @if (group) {
        <mat-list-item>
          <div
            matListItemTitle
            [ngStyle]="getStyles()"
            class="hidden md:grid 5 w-full items-center"
            >
            <div class="flex flex-col col-span-2">
              <div class="font-semibold font-efSans-primary">
                <T
                str="Emil Frey AG"
                key="customerPortal.customer-portal.communication.group.name"
                tags="customer-portal, 3.1"
              ></T>
            </div>
            <div class="font-efSans-primary text-sm">
              <T
              str="Badenerstrasse 600, 8048 Zürich, Schweiz"
              key="customerPortal.customer-portal.communication.group.street"
              tags="customer-portal, 3.1"
            ></T>
          </div>
        </div>
        @for (channel of headingChannels; track channel) {
          <span
            class="grid-list-items list-none"
            >
            @if (!checkIfDisabled(group, channel.name)) {
              <mat-checkbox
                class="h-6 w-6 float-right"
                [disabled]="!checkIfExist(group, channel.name)"
                (click)="errorMessage(channel.name)"
                (keyup)="errorMessage(channel.name)"
                color="primary"
                [checked]="getConsentGroup(channel.name)"
            (change)="
              updateConsentValue('group', group.id, channel.name, $event)
            "
                >
              </mat-checkbox>
            }
          </span>
        }
      </div>
      <div matListItemLine class="grid md:hidden">
        <div class="flex flex-col">
          <div class="font-semibold font-efSans-primary">
            <T
            str="Emil Frey AG"
            key="customerPortal.customer-portal.communication.group.name"
            tags="customer-portal, 3.1"
          ></T>
        </div>
        <div class="font-efSans-primary text-sm">
          <T
          str="Badenerstrasse 600, 8048 Zürich, Schweiz"
          key="customerPortal.customer-portal.communication.group.street"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    </div>
    <div class="flex flex-col gap-5 my-4">
      @for (channel of headingChannels; track channel) {
        <span
          class="grid-list-items flex justify-between items-center"
          [ngClass]="{ hidden: checkIfDisabled(group, channel.name) }"
          >
          <h6 matListItemLine>
            @if (!checkIfDisabled(group, channel.name)) {
              <ng-container
                  *ngTemplateOutlet="
                    communication;
                    context: { channel: channel }
                  "
              ></ng-container>
            }
          </h6>
          @if (!checkIfDisabled(group, channel.name)) {
            <mat-checkbox
              class="h-6 w-6"
              [disabled]="!checkIfExist(group, channel.name)"
              (click)="errorMessage(channel.name)"
              (keyup)="errorMessage(channel.name)"
              color="primary"
              [checked]="getConsentGroup(channel.name)"
              (change)="
                updateConsentValue('group', group.id, channel.name, $event)
              "
              >rr</mat-checkbox
              >
            }
          </span>
        }
      </div>
    </div>
    <mat-divider></mat-divider>
  </mat-list-item>
}
@if (subGroups?.length > 0) {
  <mat-list-item>
    @for (subGroup of subGroups; track subGroup.id) {
      <div
        matListItemTitle
        [ngStyle]="getStyles()"
        class="hidden md:grid w-full items-center"
        >
        <span class="flex flex-col col-span-2">
          <span
            class="font-efSans font-semibold text-mat-ef-revolution-primary-500"
            >
            {{ subGroup.name }}
          </span>
          <span class="font-efSans-primary text-sm">
            {{ subGroup.street }}{{ subGroup.zip ? ', ' + subGroup.zip : '' }} {{ subGroup.city }}
          </span>
        </span>
        @for (channel of headingChannels; track channel.name) {
          <span class="grid-list-items list-none">
            @if (!checkIfDisabled(subGroup, channel.name)) {
              <mat-checkbox
                class="h-6 w-6 float-right"
                color="primary"
                [disabled]="!checkIfExist(subGroup, channel.name)"
                [checked]="getConsentSubGroup(subGroup.id, channel.name)"
                (click)="errorMessage(channel.name)"
                (keyup)="errorMessage(channel.name)"
                (change)="updateConsentValue('subGroup', subGroup.id, channel.name, $event)"
              ></mat-checkbox>
            }
          </span>
        }
      </div>
    }
    @for (subGroup of subGroups; track subGroup.id) {
      <div matListItemLine class="grid md:hidden">
        <span class="flex flex-col">
          <span class="font-semibold font-efSans-primary">
            {{ subGroup.name }}
          </span>
          <span class="font-efSans-primary text-sm">
            {{ subGroup.street }}{{ subGroup.zip ? ', ' + subGroup.zip : '' }} {{ subGroup.city }}
          </span>
        </span>
        <div class="flex flex-col gap-5 my-4">
          @for (channel of headingChannels; track channel.name) {
            <span
              class="grid-list-items flex justify-between items-center"
              [ngClass]="{ hidden: checkIfDisabled(subGroup, channel.name) }"
              >
              <h6 matListItemLine>
                @if (!checkIfDisabled(subGroup, channel.name)) {
                  <ng-container
                        *ngTemplateOutlet="
                          communication;
                          context: { channel: channel }
                        "
                  ></ng-container>
                }
              </h6>
              @if (!checkIfDisabled(subGroup, channel.name)) {
                <mat-checkbox
                  class="h-6 w-6"
                  color="primary"
                  [disabled]="!checkIfExist(subGroup, channel.name)"
                  [checked]="getConsentSubGroup(subGroup.id, channel.name)"
                  (click)="errorMessage(channel.name)"
                  (keyup)="errorMessage(channel.name)"
                    (change)="
                      updateConsentValue('subGroup', subGroup.id, channel.name, $event)
                    "
                ></mat-checkbox>
              }
            </span>
          }
        </div>
      </div>
    }
    <mat-divider></mat-divider>
  </mat-list-item>
}
@if (brands?.length > 0) {
  <mat-list-item>
    @for (b of brands; track b; let last = $last) {
      <div
        matListItemTitle
        [ngStyle]="getStyles()"
        class="hidden md:grid w-full items-center"
        >
        <span class="flex flex-col col-span-2" [ngClass]="{'mb-3': !last}">
          <span class="font-semibold font-efSans-primary">
            {{ b.name }}
          </span>
          <span class="font-efSans-primary text-sm">
            {{ b.street }}{{ b.zip ? ', ' + b.zip : '' }} {{ b.city }}
          </span>
        </span>
        @for (channel of headingChannels; track channel) {
          <span
            class="grid-list-items list-none"
            >
            @if (!checkIfDisabled(b, channel.name)) {
              <mat-checkbox
                class="h-6 w-6 float-right"
                [disabled]="!checkIfExist(b, channel.name)"
                (click)="errorMessage(channel.name)"
                (keyup)="errorMessage(channel.name)"
                color="primary"
                [checked]="getConsentBrand(b.id, channel.name)"
                (change)="updateConsentValue('brand', b.id, channel.name, $event)"
              ></mat-checkbox>
            }
          </span>
        }
      </div>
    }
    @for (b of brands; track b) {
      <div matListItemLine class="grid md:hidden">
        <span class="flex flex-col">
          <span class="font-semibold font-efSans-primary">
            {{ b.name }}
          </span>
          <span class="font-efSans-primary text-sm">
            {{ b.street }}{{ b.zip ? ', ' + b.zip : '' }} {{ b.city }}
          </span>
        </span>
        <div class="flex flex-col gap-5 my-4">
          @for (channel of headingChannels; track channel) {
            <span
              class="grid-list-items flex justify-between items-center"
              [ngClass]="{ hidden: checkIfDisabled(b, channel.name) }"
              >
              <h6 matListItemLine>
                @if (!checkIfDisabled(b, channel.name)) {
                  <ng-container
                  *ngTemplateOutlet="
                    communication;
                    context: { channel: channel }
                  "
                  ></ng-container>
                }
              </h6>
              @if (!checkIfDisabled(b, channel.name)) {
                <mat-checkbox
                  class="h-6 w-6"
                  [disabled]="!checkIfExist(b, channel.name)"
                  (click)="errorMessage(channel.name)"
                  (keyup)="errorMessage(channel.name)"
                  color="primary"
                  [checked]="getConsentBrand(b.id, channel.name)"
                  (change)="updateConsentValue('brand', b.id, channel.name, $event)"
                ></mat-checkbox>
              }
            </span>
          }
        </div>
      </div>
    }
    <mat-divider></mat-divider>
  </mat-list-item>
}
</mat-list>
}
@if (newGdprNotice) {
  <div class="grid gap-3 mt-4">
    <p
      class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
      >
      <T
      str="The declaration of consent can be revoked or changed at any time for the future and without giving reasons. Simply send us a message (e.g. with the e-mail you have stored with us)."
      key="customerPortal.customer-portal.communication.gdpr.bottom-notice1"
      tags="customer-portal, 3.1"
    ></T>
  </p>
  <p
    class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
    >
    <T
    str="Your personal data will be treated confidentially in accordance with data protection regulations. A profile is created for the purposes mentioned."
    key="customerPortal.customer-portal.communication.gdpr.bottom-notice2"
    tags="customer-portal, 3.1"
  ></T>
</p>
<!-- prettier-ignore -->
<p
  class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
  [innerHTML]="getTranslation4()"
></p>
</div>
}
@if (!newGdprNotice) {
  <div class="grid gap-3 mt-4">
    <p
      class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
      >
      <T
      str="Contact is made for advertising purposes, for invitations to product presentations and test drives, and for market research purposes, including satisfaction surveys. For this purpose, the personal data provided is evaluated and analyzed in order to enable a customer-specific approach and to be able to submit tailor-made offers."
      key="customerPortal.customer-portal.communication.gdpr-notice2"
      tags="customer-portal, 3.1"
    ></T>
  </p>
  <!-- prettier-ignore -->
  @if (editDisabled) {
    <p
      class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
      [innerHTML]="getTranslation5()"
      >
      <T
      str="gdpr notice ch"
      key="customerPortal.customer-portal.communication.gdpr-notice-ch"
      tags="customer-portal, 3.1"
    ></T>
  </p>
}
<p
  class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
  >
  <T
  str="Further information on data protection and your rights in this regard can be found in the"
  key="customerPortal.customer-portal.communication.gdpr-notice3"
  tags="customer-portal, 3.1"
></T>
<a href="{{ privacyLink.url }}" target="_blank">
  {{ privacyLink.translation }}</a
  >
</p>
</div>
}
@if (group && !editDisabled) {
  <div
    class="flex flex-row-reverse max-w-[1000px] mt-2.5"
    >
    <button
      mat-button
      mat-flat-button
      color="secondary"
      id="saveButton"
      class="revolution"
      (click)="updateConsents()"
      [disabled]="disabled || updates.length === 0"
      >
      @if (disabled) {
        <mat-spinner [diameter]="16"></mat-spinner
          >
          }<span> {{ 'save' | sharedTranslate }}</span>
        </button>
      </div>
    }
  </div>
}

<ng-template #communication let-channel="channel">
  {{
  {
  str: channel.name,
  prefix: 'customerPortal.customer-portal.communication.'
  } | transifexTranslate
  }}
</ng-template>
